import React, { useEffect, useState } from "react"
import { Form } from "react-bootstrap"
import { arrowDownIcon, arrowUpIcon } from "../../../constants/icons"
import ReportErrorModal from "../../../components/modal/ReportErrorModal"
import RemoveBookmark from "../../../components/modal/RemoveBookmark"

const ExamPaperCard = ({
  id,
  title,
  bodyContent,
  footerContent,
  onCheckboxChange,
  isChecked,
  setShowToastSnackbar,
  bookMarkIconBtn,
  onBookmarkClick,
  onBodyClick,
}) => {
  const [examCheckbox, setExamCheckbox] = useState(false)
  const [expandedExamPaper, setExpandedExamPaper] = useState(false)
  const [showModal, setShowModal] = useState(false)

  const reportErrorHandler = (e) => {
    e.stopPropagation()
    setShowModal(true)
  }
  const handleClose = () => setShowModal(false)

  const expandedExamHandler = (e) => {
    e.stopPropagation()
    setExpandedExamPaper((prevState) => !prevState)
  }

  const handleCheckboxChange = (e) => {
    e.stopPropagation()
    const isChecked = e.target.checked
    setExamCheckbox(isChecked)
    onCheckboxChange(isChecked)
    if (setShowToastSnackbar) {
      setShowToastSnackbar(isChecked)
    }
  }

  useEffect(() => {
    setExamCheckbox(isChecked)
  }, [isChecked])

  return (
    <>
      <div
        className={`exam-papper-card ${
          examCheckbox ? "card-active-checkbox" : ""
        }`}
      >
        <div className='exam-papper-card-header'>
          <div className='exam-papper-checkbox-wrap'>
            {/* <Form.Group controlId={`checkbox-${id}`}>
              <Form.Check
                className='text-checkbox'
                type='checkbox'
                checked={examCheckbox}
                onChange={handleCheckboxChange}
                onClick={(e) => e.stopPropagation()}
              />
            </Form.Group> */}
            {bookMarkIconBtn && (
              <span
                role='button'
                className='bookmark-icon-btn'
                onClick={onBookmarkClick}
              >
                {bookMarkIconBtn}
              </span>
            )}
            <h4>{title}</h4>
          </div>
          <div className='exam-papper-btn-wrap'>
            <span
              role='button'
              className='report-error'
              onClick={reportErrorHandler}
            >
              Report Error
            </span>
            <span
              role='button'
              className='expanded-icon'
              onClick={expandedExamHandler}
            >
              {expandedExamPaper ? <>{arrowUpIcon}</> : <>{arrowDownIcon}</>}
            </span>
          </div>
        </div>
        <div
          className={`exam-papper-card-body ${
            expandedExamPaper ? "expanded-papper-height" : ""
          }`}
          style={{
            width: "100%",
            cursor: "pointer",
            height: expandedExamPaper ? 370 : 300,
            overflow: "hidden",
          }}
          onClick={onBodyClick}
        >
          {bodyContent}
        </div>
        <div className='exam-papper-card-footer'>{footerContent}</div>
      </div>

      <ReportErrorModal
        show={showModal}
        handleClose={handleClose}
        questionText={title}
        questionId={id}
      />
    </>
  )
}

export default ExamPaperCard
